"use client";

import { useEffect } from "react";

import ApartmentList from "@/components/sections/Apartments/ApartmentList";
import { useLanguage } from "@/contexts/LanguageContext";
import type { Apartment, HolidayApartment } from "@/payload-types";
import type { PayLoadData } from "@/utils/payloadUtil";

export function ApartmentsPageContent({
  pageData,
}: {
  pageData: PayLoadData<HolidayApartment> | undefined;
}) {
  const { language } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ApartmentList
        apartments={
          (pageData?.[language].apartments?.map(({ apartment }) => apartment) ||
            []) as Apartment[]
        }
      />
    </>
  );
}
